import Link from '@/atoms/Link/Link'
import FooterExtra from '@/cmp/molecules/Footer/FooterExtra'
import FooterRights from '@/cmp/molecules/Footer/FooterRights'

/* utils */
import { dataLayerFooterClickEvent } from '@/utils/functions/dataLayerEvents'

interface Props {
  resources: FooterLink[]
}

interface FooterSectionProps {
  title: string
  links: FooterLink[]
}

function Footer({ resources }: Props): JSX.Element {
  return (
    <footer>
      <section className="container grid sm:grid-cols-2 lg:grid-cols-5 gap-x-8 | px-5 pt-8 pb-6 sm:px-10 lg:px-6 mx-auto">
        <div>
          <FooterSection title="Product" links={productLinks} />
          <FooterSection title="About Pepper Content" links={aboutLinks} />
        </div>
        <div>
          <FooterSection title="Features" links={featureLinks} />
          {/* <FooterSection title="Videos" links={videos} /> */}
        </div>
        <div>
          <FooterSection title="Services" links={servicesLinks} />
          {/* <FooterSection title="Languages" links={languages} /> */}
        </div>
        <div>
          <FooterSection title="Resources" links={resources} />
        </div>
        <div>
          <FooterSection title="Comparison" links={comparisonPageLinks} />
        </div>
      </section>

      <hr className="container  |  border-blue-20  |  px-5 lg:mx-auto" />

      <FooterExtra />

      <hr className="container  |  border-blue-20   |  px-5 lg:mx-auto" />

      <FooterRights />
    </footer>
  )
}

function FooterSection({ title, links }: FooterSectionProps): JSX.Element {
  return (
    <div className="mb-6 lg:mb-8">
      <h3 className="text-yellow-80 text-small font-medium uppercase  | mb-5">
        {title}
      </h3>
      <ul className="space-y-2">
        {links.map(item => (
          <li key={item.slug}>
            <Link
              className="text-blue-web-90 text-sm | inline-block focus:outline-none focus:text-blue-50 hover:text-blue-50"
              href={item.slug}
              onClick={() => {
                dataLayerFooterClickEvent({
                  navigationMenuName: item.page_title,
                  subCategory1: title
                })
              }}
            >
              {item.page_title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

const productLinks = [
  {
    slug: '/product/content-marketing-platform/',
    page_title: 'Content Marketing Platform'
  },
  {
    slug: '/product/gen-ai/',
    page_title: 'Gen AI for enterprises'
  },
  {
    slug: '/product/organic-marketing-stack/',
    page_title: 'Organic Marketing Stack'
  },
  {
    slug: '/product/talent-marketplace/',
    page_title: 'Expert Talent'
  },
  {
    slug: '/product/content-os/',
    page_title: 'Content OS'
  }
]

const aboutLinks = [
  { slug: '/case-study/', page_title: 'Customers' },
  { slug: '/careers/', page_title: 'Culture & Careers' }
]

const servicesLinks = [
  {
    slug: '/writing-services/blog-writing-services/',
    page_title: 'Blog Writing Services'
  },
  { slug: '/video-services/', page_title: 'Video Production' },
  {
    slug: '/language-services/',
    page_title: 'Localization'
  },
  {
    slug: '/writing-services/white-paper-writing/',
    page_title: 'Whitepapers'
  },
  {
    slug: '/writing-services/thought-leadership-writing-services/',
    page_title: 'Thought Leadership'
  },
  {
    slug: '/language-services/subtitling/',
    page_title: 'Subtitling'
  },
  {
    slug: '/video-services/voice-overs-and-dubbing/',
    page_title: 'Voice Over'
  }
]

const featureLinks = [
  { slug: '/peppertype-ai/', page_title: 'Peppertype AI' },
  { slug: '/features/content-idea-lab/', page_title: 'Content Idea lab' },
  { slug: '/features/content-editor/', page_title: 'Content Editor' },
  {
    slug: '/features/content-audit/',
    page_title: 'Content Audit'
  },
  {
    slug: '/features/measure-content-roi/',
    page_title: 'Content RoI and Analytics'
  },
  {
    slug: '/features/content-grader/',
    page_title: 'Content Grader'
  }
]

const comparisonPageLinks = [
  {
    slug: '/comparison/pepper-vs-clearscope/',
    page_title: 'vs Clearscope'
  },
  {
    slug: '/comparison/pepper-vs-conductor/',
    page_title: 'vs Conductor'
  },
  {
    slug: '/comparison/pepper-vs-jasper/',
    page_title: 'vs Jasper'
  },
  {
    slug: '/comparison/pepper-vs-marketmuse/',
    page_title: 'vs Marketmuse'
  },
  {
    slug: '/comparison/pepper-vs-optimizely/',
    page_title: 'vs Optimizely'
  },
  {
    slug: '/comparison/pepper-vs-semrush/',
    page_title: 'vs Semrush'
  },
  {
    slug: '/comparison/pepper-vs-surferseo/',
    page_title: 'vs Surferseo'
  },
  {
    slug: '/comparison/pepper-vs-writer/',
    page_title: 'vs Writer'
  }
]

export default Footer
